import React, { Suspense, useContext, useEffect, useState } from "react";
import { OperationContext } from "../CreateOperation";
import { TitleBadge } from "../components/TitleBadge";
import { Empty, Form } from "antd";
import { CustomTabs } from "../../../../../common/components/Tabs/CustomTabs";
import { capitalizeFirstLetter } from "../../../../../utilities/string";
import { Loader } from "../../../../../common/components/Loader/Loader";

export const ExecutionReport = () => {
  const [form] = Form.useForm();

  const { initialValue } = useContext(OperationContext);
  const [tabItems, setTabItems] = useState<Array<any>>([]);
  const [shouldRefreshTabs, setShouldRefreshTabs] = useState(false);

  useEffect(() => {
    setTabItems(
      initialValue?.debarkationMovement?.loadPossessionStatus?.map(
        (item: any) => {
          const Component = DynamicComponent(capitalizeFirstLetter(item?.id));
          return {
            ...item,
            key: item?.id,
            label: item?.name,
            children: (
              <Suspense fallback={<Loader isLoading />}>
                {Component && <Component />}
              </Suspense>
            ),
          };
        }
      )
    );
    setShouldRefreshTabs(false);
  }, [initialValue, shouldRefreshTabs]);

  const DynamicComponent = (name: string) => {
    try {
      return React.lazy(() => import(`./${name}List.tsx`));
    } catch (error) {
      console.error("Error loading component", error);
      return null;
    }
  };

  return (
    <>
    {
      tabItems ? (
      <div>
        <div className="d-flex flex-wrap gap-2 mb-4">
          <TitleBadge
            label="Référence du voyage"
            value={initialValue?.travelReference}
          />
          <TitleBadge
            label="Opération"
            value={initialValue?.operationType?.label}
          />
          <TitleBadge label="Client" value={initialValue?.customer?.label} />
        </div>

        <div className="">
          {tabItems?.length && (
            <CustomTabs items={tabItems} tabName="mouvement" isSetDefaultActive />
          )}
        </div>
      </div>
      ) : (
        <Empty description="En attente de manifeste"/>
      )
    }
    </>
  );
};
